/**
################################## BEECLEVER GMBH KOBLENZ ###################################
##### Copyright (c) 2019-present, beeclever GmbH Koblenz DE, All rights reserved.       #####
##### THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR        #####
##### IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS  #####
##### FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR    #####
##### COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER    #####
##### IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN           #####
##### CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.        #####
##### LICENSED TO "LIVOM MOEBEL AG"                                                     #####
##### USAGE GRANTED FOR "LIVOM.DE" / "livomde.myshopify.com". NO FURTHER DISTRIBUTION!  #####
#############################################################################################
*/

Shopify = Shopify || {};
Shopify.beeclever = Shopify.beeclever || {};
Shopify.beeclever.configurator = Shopify.beeclever.configurator || {};
Shopify.beeclever.configurator.debugMode =
  Shopify.beeclever.configurator.debugMode || false;

import * as THREE from "three";
import {
  DEFAULT_LAYER,
  GROUND_LAYER,
  BASE_MODULE_LAYER,
  TOP_MODULE_LAYER,
  ACCESSORY_MODULE_LAYER,
  MODULE_LAYER,
  DEBUG_LAYER,
  GRID_SNAP_SIZE,
  SNAP_POINT_RADIUS,
  Y_POSITIVE,
  MAX_CLICK_DURATION,
} from "livom-configurator-definitions";

import {
  Time,
  MousePickPass,
  Tools,
  LivomModule,
  LivomModulePreset,
} from "livom-configurator-utilities";

class CursorTools {
  constructor(
    renderer,
    camera,
    scene,
    controls,
    container,
    outlinePass = null
  ) {
    this.camera = camera;
    this.scene = scene;
    this.controls = controls;
    this.container = container;
    this.raycaster = new THREE.Raycaster();
    this.mousePixelPosition = new THREE.Vector2();
    this.mousePosition = new THREE.Vector2();
    this.lastModulePosition = new THREE.Vector3(0, 0, 0);
    this.cursorPosition = new THREE.Vector3(0, 0, 0);
    this.intersectedObject = null;
    this.draggedObject = null;
    this.snapped = false;
    this.lastMouseDown = null;
    this.renderer = renderer;
    this.mousePicking = new MousePickPass(renderer, camera);
    this.dragstart = false;

    this.groundPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    this.groundPlaneIntersection = new THREE.Vector3();

    this.outlinePass = outlinePass;
    this.selectedObjects = [];

    this.setupDragOverEvent();
    // this.setupDragEnterEvent()
    // this.setupDragLeaveEvent()
    this.setupDropEvent();

    this.setupMouseMoveEvent();
    this.setupMouseDownEvent();
    this.setupMouseUpEvent();

    this.setupTouchMoveEvent();
    this.setupTouchStartEvent();
    this.setupTouchEndEvent();

    this.setupConfigurationUpdateEvent();
  }
  setupConfigurationUpdateEvent() {
    const that = this;
    window.addEventListener("configurator:configuration:update", (e) => {
      //window.dispatchEvent(new Event('configurator:camera:center'))
      that.updateConfiguration();
    });
  }
  //Drag Events
  setupDragOverEvent() {
    const that = this;
    function onDragOver(e) {
      e.preventDefault();
      that.moving(e);
      that.dragging(e);
    }
    that.container.addEventListener("dragover", onDragOver, false);
  }
  setupDragEnterEvent() {
    const that = this;
    function onDragEnter(e) {
      e.preventDefault();
      that.moving(e);
      that.dragging(e);
    }
    that.container.addEventListener("dragenter", onDragEnter, false);
  }
  setupDropEvent() {
    const that = this;
    function onDrop(e) {
      e.preventDefault();
      that.drop(e);
      that.intersectedObject = that.getObject();
    }
    that.container.addEventListener("drop", onDrop, false);
  }
  setupDragLeaveEvent() {
    const that = this;
    function onDragLeave(e) {
      e.preventDefault();
      that.drop(e);
    }
    that.container.addEventListener("dragleave", onDragLeave, false);
  }
  //Mouse Events
  setupMouseDownEvent() {
    const that = this;
    function onMouseDown(e) {
      if (e.target.closest("aside.sidebar")) {
        return;
      }
      if (e.target.closest("div.livom-module-ui")) {
        return;
      }
      //Set Time of click
      that.lastMouseDown = Time.getCurrentTime();
      if (!!that.intersectedObject) {
        // bekommt in der Buybox nicht 0,0,0 zugewiesen.
        that.lastModulePosition = new THREE.Vector3(
          that.intersectedObject.position.x,
          that.intersectedObject.position.y,
          that.intersectedObject.position.z
        );
        that.drag(that.intersectedObject, true);
      } else {
        //Hide UI to prevent Model not droppable bug
        that.closeModuleUIAll(false);
      }
    }
    that.container.addEventListener("mousedown", onMouseDown, false);
  }
  setupMouseMoveEvent() {
    const that = this;
    function onMouseMove(e) {
      that.moving(e);
      if (!!that.draggedObject) {
        that.dragging(e);
      }
    }
    that.container.addEventListener("mousemove", onMouseMove, false);
  }
  setupMouseUpEvent() {
    const that = this;
    function onMouseUp(e) {
      if (!e.target.closest("div.livom-module-ui")) {
        let clickDuration = Time.getTimeSince(that.lastMouseDown);
        if (clickDuration < MAX_CLICK_DURATION) {
          //Is click
          //Cancle drag
          if (!!that.draggedObject) {
            that.mousePicking.addObject(that.draggedObject);
            that.draggedObject = null;
          }
          that.controls.enabled = true;
          that.openModuleUI();
        } else if (!!that.draggedObject) {
          //Is drag end
          // let isItTheLastPosition = that.lastModulePosition;
          that.drop(e);
        }
        //Update intersected Object to enable clicking for dropped object
        that.intersectedObject = that.getObject();
      }
    }
    that.container.addEventListener("mouseup", onMouseUp, false);
  }
  //Touch events
  setupTouchStartEvent() {
    const that = this;
    function onTouchStart(e) {
      //e.preventDefault();
      if (!e.target.closest("div.livom-module-ui")) {
        that.moving(e);
        //Set Time of click
        that.lastMouseDown = Time.getCurrentTime();
        if (!!that.intersectedObject) {
          that.lastModulePosition = new THREE.Vector3(
            that.intersectedObject.position.x,
            that.intersectedObject.position.y,
            that.intersectedObject.position.z
          );
          that.drag(that.intersectedObject, true);
        } else {
          //Hide UI to prevent Model not droppable bug
          that.closeModuleUIAll(false);
        }
      }
    }
    that.container.addEventListener("touchstart", onTouchStart, false);
  }
  setupTouchMoveEvent() {
    const that = this;
    function onTouchMove(e) {
      // should only use the moving method of cursor-tools so that there is no real scrolling
      // if in sidebar-inner, then no prevent default
      //e.preventDefault();
      that.moving(e);
      if (!!that.draggedObject) {
        that.dragging(e);
      }
    }
    that.container.addEventListener("touchmove", onTouchMove, false);
  }
  setupTouchEndEvent() {
    const that = this;
    function onTouchEnd(e) {
      // e.preventDefault();
      if (!e.target.closest("div.livom-module-ui")) {
        that.moving(e);
        let clickDuration = Time.getTimeSince(that.lastMouseDown);
        if (clickDuration < MAX_CLICK_DURATION) {
          //Is click
          //Cancle drag
          if (!!that.draggedObject && e.target.closest("canvas")) {
            that.mousePicking.addObject(that.draggedObject);
            that.draggedObject = null;
          } else if (!!that.draggedObject && e.target.closest(".mobile-show")) {
            that.draggedObject.delete();
            that.draggedObject = null;
            that.updateConfiguration();
            return;
          }
          // that.intersectedObject = that.getObject();
          that.controls.enabled = true;
          that.openModuleUI();
        }
        // and the dragged object is in viewport
        // when it crosses the sidebar or the mobile show, then delete module?
        else if (!!that.draggedObject) {
          //Is drag end
          that.drop(e);
        }
        //Update intersected Object to enable clicking for dropped object
        that.intersectedObject = that.getObject();
      }
    }
    that.container.addEventListener("touchend", onTouchEnd, false);
  }

  mouseOutOfBounds(x, y) {
    let containerBCR = this.container.getBoundingClientRect();
    return (
      x <= containerBCR.x ||
      x > containerBCR.x + containerBCR.width ||
      y <= containerBCR.y ||
      y > containerBCR.y + containerBCR.height
    );
  }
  updateMousePosition(x, y) {
    this.mousePixelPosition.x = x - this.container.getBoundingClientRect().left;
    this.mousePixelPosition.y = y - this.container.getBoundingClientRect().top;
    this.mousePosition.x =
      (this.mousePixelPosition.x / this.container.offsetWidth) * 2 - 1;
    this.mousePosition.y =
      -(this.mousePixelPosition.y / this.container.offsetHeight) * 2 + 1;
  }
  getPositionOnFloor() {
    const that = this;
    let viewport = new THREE.Vector4();
    this.renderer.getCurrentViewport(viewport);
    let viewportMousePos = new THREE.Vector2(
      ((this.mousePixelPosition.x * window.devicePixelRatio - viewport.x) /
        viewport.z) *
        2 -
        1,
      -(
        (this.mousePixelPosition.y * window.devicePixelRatio - viewport.y) /
        viewport.w
      ) *
        2 +
        1
    );
    that.raycaster.setFromCamera(viewportMousePos, that.camera);
    that.raycaster.ray.intersectPlane(
      that.groundPlane,
      that.groundPlaneIntersection
    );
  }

  getObject(layer = MODULE_LAYER) {
    let cbcr = document.querySelector("canvas").getBoundingClientRect();
    if (this.mousePixelPosition.y < cbcr.height) {
      let o = this.mousePicking.getObjectAt(
        this.mousePixelPosition.x,
        this.mousePixelPosition.y,
        layer
      );
      this.updateMouseCursor();
      return o;
    } else {
      this.updateMouseCursor();
      return null;
    }
  }
  //Executed once per frame
  update() {}

  updateMouseCursor() {
    this.container.style.cursor = !!this.intersectedObject
      ? this.intersectedObject.isLocked()
        ? "not-allowed"
        : "grab"
      : "";
    this.container.style.cursor = !!this.draggedObject
      ? "grabbing"
      : this.container.style.cursor;
  }
  getSnapPositionOnFloor() {
    const that = this;
    that.getPositionOnFloor();
    that.cursorPosition.copy(that.groundPlaneIntersection);
    // that.cursorPosition.set(
    //     Math.round(that.cursorPosition.x / GRID_SNAP_SIZE.x) * GRID_SNAP_SIZE.x,
    //     Math.round(that.cursorPosition.y / GRID_SNAP_SIZE.y) * GRID_SNAP_SIZE.y,
    //     Math.round(that.cursorPosition.z / GRID_SNAP_SIZE.z) * GRID_SNAP_SIZE.z
    // )
    return that.cursorPosition;
  }

  snapToModules() {
    const that = this;
    this.removeObject = false;
    let nearestMDist = Number.MAX_SAFE_INTEGER;
    let nearestM = null;
    //find nearest module
    for (const m of that.scene.children) {
      if (
        m != that.draggedObject &&
        m.layers.isEnabled(BASE_MODULE_LAYER) &&
        m.hasAvailableSnapPointBase()
      ) {
        let mW = new THREE.Vector3();
        m.getWorldPosition(mW);
        let dist = that.cursorPosition.distanceToSquared(mW);
        if (dist < nearestMDist) {
          nearestMDist = dist;
          nearestM = m;
        }
      }
    }

    //find nearest snappoint --> distant
    if (!!nearestM) {
      if (
        nearestMDist >=
        (nearestM.snapRadius + that.draggedObject.snapRadius) * 0.6
      ) {
        return;
      }
      //Sort Snappoints of nearest module by distance
      let spsSorted = nearestM.snapPointsBase?.children.filter((sp) =>
        sp.isAvailableFor(that.draggedObject)
      );
      spsSorted = spsSorted.sort((a, b) => {
        let aspW = new THREE.Vector3();
        a.getWorldPosition(aspW);
        let distA = that.cursorPosition.distanceToSquared(aspW);
        let bspW = new THREE.Vector3();
        b.getWorldPosition(bspW);
        let distB = that.cursorPosition.distanceToSquared(bspW);
        if (distA < distB) {
          return -1;
        } else if (distA > distB) {
          return 1;
        } else {
          return 0;
        }
      });
      //sort snappoints of current module by distance
      let spMsSorted = that.draggedObject.snapPointsBase?.children;
      let nearestMW = new THREE.Vector3();
      nearestM.getWorldPosition(nearestMW);
      spMsSorted = spMsSorted.sort((a, b) => {
        let aspW = new THREE.Vector3();
        a.getWorldPosition(aspW);
        let distA = nearestMW.distanceToSquared(aspW);
        let bspW = new THREE.Vector3();
        b.getWorldPosition(bspW);
        let distB = nearestMW.distanceToSquared(bspW);
        if (distA < distB) {
          return -1;
        } else if (distA > distB) {
          return 1;
        } else {
          return 0;
        }
      });

      that.draggedObject.visible = true;
      for (const spm of spMsSorted) {
        innerloop: for (const sp of spsSorted) {
          let rotatedSpNormal = spm.normal
            .clone()
            .applyEuler(new THREE.Euler(0, -that.draggedObject.rotation.y, 0));
          let rotatedNearesNormal = sp.normal
            .clone()
            .applyEuler(new THREE.Euler(0, -nearestM.rotation.y, 0));
          if (
            Tools.correctAngle(rotatedSpNormal.dot(rotatedNearesNormal)) ==
              -1 &&
            spm.isAvailableFor(nearestM)
          ) {
            //
            spm.snapTo(sp);
            let draggedAabb = that.draggedObject.checkBoundingBox.clone();
            that.draggedObject.updateMatrixWorld(true);
            draggedAabb.applyMatrix4(that.draggedObject.matrixWorld);
            // let draggedBb = new THREE.Box3().setFromObject(that.draggedObject);
            for (const m of that.scene.children) {
              if (
                !(m.uuid === that.draggedObject.uuid) &&
                m.isLivomModule &&
                m.moduleType === "Base"
              ) {
                // let mbb = new THREE.Box3().setFromObject(m)// new THREE.Box3().setFromCenterAndSize(m.position.clone().add(m.boundingBoxCenterOffset), m.boundingBoxSize)
                let mAabb = m.checkBoundingBox.clone();
                m.updateMatrixWorld(true);
                mAabb.applyMatrix4(m.matrixWorld);
                if (draggedAabb.intersectsBox(mAabb)) {
                  // console.log(m, that.draggedObject, "intersection");
                  spm.unsnap(sp);
                  continue innerloop;
                }
              }
            }
            return;
          }
        }
      }
      that.removeObject = true;
      // hier war mal was
    }
  }

  snapToModule(layer = BASE_MODULE_LAYER) {
    const that = this;
    that.removeObject = false;
    let nearestSpDist = Number.MAX_SAFE_INTEGER;
    let nearestSp = null;
    if (
      layer == BASE_MODULE_LAYER ||
      (layer == TOP_MODULE_LAYER && that.draggedObject.moduleType == "Top")
    ) {
      if (!!that.intersectedObject.snapPointsTop) {
        for (const sp of that.intersectedObject.snapPointsTop.children) {
          // Find nearest unoccupied snap point that allows the dragged object to snap to it
          if (sp.isAvailableFor(that.draggedObject)) {
            let spW = new THREE.Vector3();
            sp.getWorldPosition(spW);
            let dist = that.cursorPosition.distanceToSquared(spW);
            if (dist < nearestSpDist) {
              nearestSpDist = dist;
              nearestSp = sp;
            }
          }
        }
      }
    }
    if (!!nearestSp) {
      //To Do: check if currently dragged module interferes with other snapped modules
      //snap bottom snap point of currently dragged object to the closest snappoint of the intersected object
      //To Do: look for problem when top module wants to snap with ihts bottomo snap to topSnapPoint
      let snapPointBottom = that.draggedObject.snapPointBottom;
      snapPointBottom.snapTo(nearestSp);
      window.snappedObject = that.draggedObject;
      that.draggedObject.visible = true;
      that.snapped = true;
    }
  }

  myOutline(model, input, uiclose = false, dragged = false) {
    const that = this;
    if (input) {
      if (model != null) {
        that.selectedObjects.push(model);
      }
      if (that.outlinePass) {
        that.outlinePass.selectedObjects = that.selectedObjects;
      }
    } else if (uiclose) {
      if (that.selectedObjects.length != 0) {
        if (
          that.selectedObjects[0].position.equals(
            new THREE.Vector3(0, 0.15, 0.5)
          ) &&
          !dragged
        ) {
          that.selectedObjects[0].position.y = 0.0;
          that.draggedObject = that.selectedObjects[0];
          that.drop();
        } else {
        }
      }
      that.selectedObjects.pop();
    }
  }

  openModuleUI() {
    const that = this;
    let vectest = new THREE.Vector3();
    that.closeModuleUIAll();
    if (!!that.intersectedObject) {
      that.intersectedObject.ui.show();
      that.intersectedObject.ui.getWorldPosition(vectest);
      that.myOutline(that.intersectedObject, true);
      if (Shopify.beeclever.configurator.debugMode) {
        console.log(vectest, "openUI");
      }
    }
  }
  closeModuleUIAll(dragged = false) {
    const that = this;
    for (const child of that.scene.children) {
      that.myOutline(that.intersectedObject, false, true, dragged);
      if (child.layers.isEnabled(MODULE_LAYER)) child.ui.hide();
    }
  }

  drag(object, dragstart = false) {
    const that = this;
    that.dragstart = dragstart;
    //Set dragged Object
    if (object.isLocked()) {
      return;
    }
    that.draggedObject = object;
    that.mousePicking.removeObject(object);
    //Disable controls
    that.controls.enabled = false;
    //Hide UI to prevent Model not droppable bug
    that.closeModuleUIAll(true);
    if (dragstart == true) {
      that.myOutline(that.draggedObject, true);
    }
    //Add object to scene if not there
    if (!!!that.scene.getObjectById(object.id)) {
      that.scene.add(object);
    }
  }

  dragging(e) {
    const that = this;
    let snapToBase = false;
    //Hide Object when mouse out of bounds
    if (that.mouseOutOfBounds(e.clientX, e.clientY)) {
      that.draggedObject.visible = false;
      that.snapped = false;
    } else if (!!that.draggedObject) {
      //When base module place on ground and snap to near by modules or when it's viewed as base module
      if (that.draggedObject.layers.isEnabled(BASE_MODULE_LAYER)) {
        //update module position
        that.draggedObject.position.copy(that.cursorPosition);
        //Move all snapped top modules to their associated snap points
        that.moveTopWithBase();
        that.draggedObject.visible = true;
        that.snapped = false;

        for (const sp of that.draggedObject.snapPointsBase.children) {
          if (sp.isSnapped()) {
            sp.unsnap();
          }
        }

        // wann kann er das hier ausfuehren? Es sollte doch dann
        that.snapToModules();
      } //When top module
      else if (that.draggedObject.layers.isEnabled(TOP_MODULE_LAYER)) {
        that.draggedObject.visible = true;
        that.intersectedObject = that.getObject(TOP_MODULE_LAYER);
        that.draggedObject.position.copy(that.cursorPosition);
        if (!!that.intersectedObject) {
          //snap to nearest snap point of intersected object
          snapToBase = false;
        }
        that.intersectedObject = that.getObject(BASE_MODULE_LAYER);
        that.draggedObject.position.copy(that.cursorPosition);
        if (!!that.intersectedObject) {
          //snap to nearest snap point of intersected object
          snapToBase = true;
          // that.snapToModule()
        }
        if (!snapToBase) {
          that.intersectedObject = that.getObject(TOP_MODULE_LAYER);
          if (that.draggedObject.snapPointBottom.isSnapped()) {
            //unsnap snappoint
            that.draggedObject.snapPointBottom.unsnap();
          }
          if (!!that.intersectedObject) {
            if (
              that.intersectedObject.serializationId !=
              that.draggedObject.serializationId
            ) {
              that.snapToModule(TOP_MODULE_LAYER);
            } else {
              that.snapped = false;
              if (!!that.draggedObject.snapPointBottom.snappedTo) {
                //unsnap snappoint
                that.draggedObject.snapPointBottom.unsnap();
              }
            }
          } else {
            that.snapped = false;
            if (!!that.draggedObject.snapPointBottom.snappedTo) {
              //unsnap snappoint
              that.draggedObject.snapPointBottom.unsnap();
            }
          }
        } else if (snapToBase) {
          if (that.draggedObject.snapPointBottom.isSnapped()) {
            //unsnap snappoint
            that.draggedObject.snapPointBottom.unsnap();
          }
          that.snapToModule();
        } else {
          //hide dragged module and unsnap (was false before)
          that.snapped = false;
          if (!!that.draggedObject.snapPointBottom.snappedTo) {
            //unsnap snappoint
            that.draggedObject.snapPointBottom.unsnap();
          }
        }
      }
      //When accessory module
      // else if(that.draggedObject.layers.isEnabled(ACCESSORY_MODULE_LAYER)){
      //     //Check if intersected object is of type base module
      //     that.intersectedObject = that.getObject(TOP_MODULE_LAYER)
      //     if(!!that.intersectedObject){
      //         if(that.draggedObject.snapPointBottom.isSnapped()){
      //             //unsnap snappoint
      //             that.draggedObject.snapPointBottom.unsnap()
      //         }
      //         //snap to nearest snap point of intersected object
      //         that.snapToModule(TOP_MODULE_LAYER)
      //     }
      //     else{
      //         //hide dragged module and unsnap
      //         that.draggedObject.visible = false;
      //         that.snapped = false
      //         if(!!that.draggedObject.snapPointBottom.snappedTo){
      //             //unsnap snappoint
      //             that.draggedObject.snapPointBottom.unsnap()
      //         }
      //     }
      // }
    }
  }
  moving(e) {
    const that = this;

    this.updateMouseCursor();

    if (e.type.includes("touch")) {
      that.updateMousePosition(
        e.changedTouches[0].clientX,
        e.changedTouches[0].clientY
      );
    } else {
      that.updateMousePosition(e.clientX, e.clientY);
    }
    that.getSnapPositionOnFloor();
    if (
      !!that.draggedObject &&
      that.draggedObject.layers.isEnabled(TOP_MODULE_LAYER)
    ) {
      that.intersectedObject = that.getObject(BASE_MODULE_LAYER);
    } else if (
      !!that.draggedObject &&
      that.draggedObject.layers.isEnabled(ACCESSORY_MODULE_LAYER)
    ) {
      that.intersectedObject = that.getObject(TOP_MODULE_LAYER);
    } else {
      that.intersectedObject = that.getObject();
    }
  }
  // else if(e.type.includes('touchend') && that.draggedObject.position.equals(new THREE.Vector3(0.0, 0.0, 0.0))) {
  //     // When still hovering over the mobile menu
  //     // prevents the user from adding modules into the scene just by touching the picture of it.
  //     that.draggedObject.delete()
  //     that.draggedObject = null
  //     that.updateConfiguration()
  //     return;
  // }
  drop(e) {
    const that = this;
    that.removeObject = false;
    if (!!that.draggedObject) {
      if (e) {
        if (
          e.type.includes("touch") &&
          that.mouseOutOfBounds(
            e.changedTouches[0].clientX,
            e.changedTouches[0].clientY
          )
        ) {
          //When out of bounds remove from scene
          that.draggedObject.delete();
          that.draggedObject = null;
          that.updateConfiguration();
          return;
        } else if (that.mouseOutOfBounds(e.clientX, e.clientY)) {
          //When out of bounds remove from scene
          that.draggedObject.delete();
          that.draggedObject = null;
          return;
        }
      }
      0;

      if (Shopify.beeclever.configurator.debugMode) {
        console.log(
          "Dropped object:",
          that.draggedObject,
          "Snapped:",
          that.snapped
        );
      }
      //Remove non snapped top modules and overlapping base modules from scene  || that.removeObject

      // if(e.type.includes("touch") )
      // if removeObject is false, then it should test again if there really is no intersection, when it's dropped.
      // Because ther is the possibility that snapToModule() will not be called, because the module isn't in range to a possible snappoint
      // Then it's possible, that a module can intersect another module without the check of intersection
      // TODO!: later on we will need to change it. When two top modules intersect (cussions), then load a different module that is a cussion that is knautscht, so there is no intersection between cussions, and it looks more realistic
      if (!that.removeObject && that.draggedObject.moduleType === "Base") {
        let draggedAabb = that.draggedObject.checkBoundingBox.clone();
        that.draggedObject.updateMatrixWorld(true);
        draggedAabb.applyMatrix4(that.draggedObject.matrixWorld);
        myLoop: for (const m of that.scene.children) {
          if (
            !(m.uuid === that.draggedObject.uuid) &&
            m.isLivomModule &&
            m.moduleType === "Base"
          ) {
            // let mbb = new THREE.Box3().setFromObject(m)// new THREE.Box3().setFromCenterAndSize(m.position.clone().add(m.boundingBoxCenterOffset), m.boundingBoxSize)
            let mAabb = m.checkBoundingBox.clone();
            m.updateMatrixWorld(true);
            mAabb.applyMatrix4(m.matrixWorld);
            // console.log(that.removeObject);
            if (draggedAabb.intersectsBox(mAabb)) {
              that.removeObject = true;
              break myLoop;
            }
          }
        }
      }
      if (
        that.draggedObject.layers.isEnabled(TOP_MODULE_LAYER) &&
        !that.snapped
      ) {
        // TODO: trigger Error Message --> deleted because intersection, please drag the element to a free place
        that.draggedObject.delete();
      } else if (that.removeObject) {
        // lastModulePosition is not that stable I think
        if (that.dragstart) {
          that.draggedObject.delete();
        } else {
          that.draggedObject.position.set(
            that.lastModulePosition.x,
            that.lastModulePosition.y,
            that.lastModulePosition.z
          );
          that.draggedObject.visible = true;
          that.mousePicking.addObject(that.draggedObject);
          // moves the top modules with the new position of the draggedObject
          that.moveTopWithBase();
        }
      } else {
        that.mousePicking.addObject(that.draggedObject);
      }
      //drop at current location/snap point
      that.draggedObject = null;
    }
    window.dispatchEvent(new Event("configurator:camera:center"));
    that.controls.enabled = true;
    that.updateConfiguration();
  }

  // moves the topModules with the attached basemodule through the scene
  moveTopWithBase() {
    const that = this;
    let snapPointsTop = that.draggedObject.snapPointsTop;
    if (!!snapPointsTop) {
      for (const sp of snapPointsTop.children) {
        if (sp.isSnapped()) {
          let snapPointWorldPos = new THREE.Vector3();
          sp.getWorldPosition(snapPointWorldPos);
          sp.snappedTo.module.position.copy(
            snapPointWorldPos.sub(sp.snappedTo.position)
          );
          if (!!sp.snappedTo.module.snapPointsTop) {
            for (const spa of sp.snappedTo.module.snapPointsTop.children) {
              if (spa.isSnapped()) {
                let spaWorldPos = new THREE.Vector3();
                spa.getWorldPosition(spaWorldPos);
                spa.snappedTo.module.position.copy(
                  spaWorldPos.sub(spa.snappedTo.position)
                );
              }
            }
          }
        }
      }
    }
  }

  dropAt(position, rotation = { _x: 0, _y: 0, _z: 0 }, init = true) {
    const that = this;
    if (!!that.draggedObject) {
      if (Shopify.beeclever.configurator.debugMode) {
        console.log(
          "Dropped object:",
          that.draggedObject,
          "Snapped:",
          that.snapped
        );
      }
      //move cursor to position and drop object
      that.cursorPosition.set(position.x, position.y, position.z);
      //update module position
      that.draggedObject.position.copy(that.cursorPosition);

      that.draggedObject.rotation.x = rotation._x;
      that.draggedObject.rotation.y = rotation._y;
      that.draggedObject.rotation.z = rotation._z;
      //add to mousePicking
      that.mousePicking.addObject(that.draggedObject);
      that.draggedObject.visible = true;
      //drop
      that.draggedObject = null;
    }
    that.controls.enabled = true;
    that.updateConfiguration();
  }
  dropOnTo(target, targetSnapPointName) {
    const that = this;
    if (!!that.draggedObject) {
      if (Shopify.beeclever.configurator.debugMode) {
        console.log(
          "Dropped object:",
          that.draggedObject,
          "Snapped:",
          that.snapped
        );
      }

      that.draggedObject.snapPointBottom.snapTo(
        target.getObjectByName(targetSnapPointName)
      );

      //add to mousePicking
      that.mousePicking.addObject(that.draggedObject);
      that.draggedObject.visible = true;
      //drop
      that.draggedObject = null;
    }
    that.controls.enabled = true;
    that.updateConfiguration();
  }

  updateConfiguration() {
    const that = this;
    let items = new Array();
    let price = 0;
    let compareAtPrice = 0;

    that.scene.traverse((o) => {
      if (o.layers.isEnabled(MODULE_LAYER)) {
        let variant = o.variants.find((v) => v.title == o.currentMaterial);
        console.log(variant);
        if (!!!variant) {
          variant = o.variants[0];
        }
        price += variant.price;
        compareAtPrice += (variant.compareAtPrice - variant.price);
        items.push({
          id: variant.id,
          productId: variant.productId,
          price: variant.price,
          quantity: 1,
          properties: {
            Material: o.currentMaterial,
            Farbe: o.currentColorName,
            _currentColor: o.currentColor,
            _volume_: variant.configPartVolume,
          },
        });
      }
    });
    let mods = new Array();
    for (const child of that.scene.children) {
      if (child.layers.isEnabled(BASE_MODULE_LAYER))
        mods.push(child.serialize());
    }

    Shopify.beeclever.configurator.configuration =
      Shopify.beeclever.configurator.configuration || [];
    Shopify.beeclever.configurator.configuration.items = items;
    Shopify.beeclever.configurator.configuration.price = price;
    Shopify.beeclever.configurator.configuration.compareAtPrice = (compareAtPrice + price);

    let url = new URL(location);
    url.searchParams.set(
      "configuration",
      encodeURIComponent(JSON.stringify(mods))
    );
    Shopify.beeclever.configurator.configuration.link = url;
    window.dispatchEvent(new Event("configurator:configuration:change"));
  }

  static applyColor(object, hex) {
    object.traverse((o) => {
      if (o.isMesh) {
        o.material.color = new THREE.Color(hex);
      }
    });
  }

  dispose() {
    this.mousePicking.dispose();
  }
}

export default CursorTools;
